import { render, staticRenderFns } from "./action-option-common.vue?vue&type=template&id=f6b6fe70&scoped=true"
import script from "./action-option-common.vue?vue&type=script&lang=js"
export * from "./action-option-common.vue?vue&type=script&lang=js"
import style0 from "./action-option-common.vue?vue&type=style&index=0&id=f6b6fe70&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b6fe70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6b6fe70')) {
      api.createRecord('f6b6fe70', component.options)
    } else {
      api.reload('f6b6fe70', component.options)
    }
    module.hot.accept("./action-option-common.vue?vue&type=template&id=f6b6fe70&scoped=true", function () {
      api.rerender('f6b6fe70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/components/setting-block-form/components/action-option-common.vue"
export default component.exports